import type { Label, LabelType } from "src/store/api/generatedApi";

export const getEventLabel = (
  labels: Label[],
  labelType: LabelType
): string | null => {
  return (
    (labels.find((label) => label.data.label_type === labelType)?.data.label as
      (string | null) | undefined) ?? null
  );
};
